import React from "react";
import { Navigate } from "react-router-dom";
import { MenuLDDLauncherChoice, PREVIOUS_PAGE_STORAGE_KEY } from "./TopMenu";

export default function Root() {
    const page = localStorage.getItem(PREVIOUS_PAGE_STORAGE_KEY) || MenuLDDLauncherChoice.key;
    return <Navigate to={page} />;
}